import './lib/import'

import Vue from 'vue'
import App from './App.vue'

import router from './router'
import store from './store'
import iView from 'view-design'
// import ViewUI from 'view-design'
import config from '@/config'
import ECharts from 'vue-echarts'
import 'view-design/dist/styles/iview.css'
import './styles/index.less'
import BaiduMap from 'vue-baidu-map'

// import 'viewerjs/dist/viewer.css'
// import Viewer from 'v-viewer'
import iviewArea from 'iview-area'
import 'echarts/lib/chart/bar'
import 'echarts/lib/chart/line'
import 'echarts/lib/chart/pie'
import 'echarts/lib/component/polar'
import 'echarts/lib/component/tooltip'
import 'echarts/lib/component/dataZoom'
import 'echarts/lib/component/title'
import 'echarts/lib/component/legend'
import 'echarts/lib/component/legendScroll'
import 'echarts/lib/component/toolbox'
import 'echarts/lib/chart/graph'

import ImageViewer from 'vue2-viewer'
Vue.use(ImageViewer)
Vue.use(iviewArea)

// Vue.use(Viewer, {
//   defaultOptions: {
//     zIndex: 9999,
//     toolbar: true,
//     url: 'alt'
//   }
// })

Vue.use(iView)
// Vue.use(ViewUI)
Vue.component('v-chart', ECharts)
Vue.config.productionTip = false
Vue.prototype.$config = config

Vue.use(BaiduMap, {
  ak: config.baiduMapKey
})

new Vue({
  store,
  router,
  render: h => h(App)
}).$mount('#app')
